import React, { FC, useState } from 'react'
import { PolaroidList } from 'components/SA/Polaroid'
import styles from './artistProfile.module.scss'
import LoadMore from './LoadMore'
import { useSelector } from 'react-redux'
import {
  getArtworks,
  getAccountUserID,
  getIsUsersArtworksAccount,
  getReasonsAllowedToSell,
} from '../selectors'
import { getScreenIsReady } from 'selectors/screen'
import { getUserID, isSessionSet } from 'selectors/user/session'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
const ArtworkPolaroidList: FC = () => {
  const artworks = useSelector(getArtworks)
  const reasonsNotAllowedToSell = useSelector(getReasonsAllowedToSell)
  const isScreenReady = useSelector(getScreenIsReady)
  const isSet = useSelector(isSessionSet)
  const userID = useSelector(getUserID)
  const artistID = useSelector(getAccountUserID)
  const isUsersArtworksAccount = useSelector(getIsUsersArtworksAccount)
  const algoliaUserToken = useSelector(getAlgoliaUserToken)
  const [results, setResults] = useState(artworks)

  const transformedArtworks = results.map((item) => ({
    artId: item.artworkID,
    artistArtworksUrl: '',
    artistRecognition: [],
    artworkId: item.artworkID,
    artworkRank: 0,
    artworkTitle: item.title,
    artworkUrl: item.pdpUrl,
    aspectRatio: item.aspectRatio,
    category: item.category,
    city: '',
    color: '',
    colorProximity: 0,
    country: '',
    curatedStatus: 0,
    depth: item.depth,
    firstName: '',
    hasLimitedEditions: false,
    hasOpenEditions: item.hasOpenEditions && !reasonsNotAllowedToSell.length,
    hasPrint: false,
    height: item.height,
    isReadyToHang: 0,
    idUser: 0,
    imageBaseUrl: (item.artworkImage || '').replace(/-6.jpg/, ''),
    imageUrl: item.artworkImage,
    isSafe: true,
    isSeoValid: true,
    keywords: [],
    lastName: '',
    legacyArtId: 0,
    listPrice: item.listPrice,
    listPrices: {},
    materials: item.materials,
    mediums: item.mediums,
    minPrintPrice: item.printPrice,
    printMaterials: item.printMaterials,
    printDimensions: item.printDimensions,
    objectID: '',
    orientation: '',
    originalStatus: item.originalStatus,
    originalUrl: '',
    printStatus: '',
    positionID: 0,
    price: item.originalPrice,
    printUrl: item.printUrl,
    printsAvailability: '',
    printsMaterials: [],
    printsPriceRanges: [],
    printsSizeRanges: [],
    printsSizes: [],
    printsSizesPrices: {},
    productStatusRank: 0,
    productUrl: item.pdpUrl,
    profileUrl: '',
    size: '',
    sku: item.productSku,
    styles: item.styles,
    subject: item.subject,
    toafCities: [],
    uploadedDate: 0,
    width: item.width,
  }))

  return (
    <div className={styles.artworkPolaroidListWrapper}>
      <div className={styles.artworkPolaroidList}>
        <PolaroidList
          dataList='plp-results'
          artworks={transformedArtworks}
          isLoading={!isScreenReady || !isSet}
          isArtistNameVisible={true}
          userID={userID}
          isMediumMaterialVisible={true}
          isUsersArtworksAccount={isUsersArtworksAccount}
          customStyle={styles.customPolaroidListContainer}
          imageSuffix='plp'
          algoliaUserToken={algoliaUserToken}
          shouldSendAlgoliaEvents={false}
        />
      </div>
      <LoadMore setResults={setResults} resultsLength={results.length || 0} artistID={artistID} />
    </div>
  )
}

export default ArtworkPolaroidList
